export default __webpack_public_path__ + "static/media/left-arrow.96414a3f.svg";